import { ChannelType, useTalkieWalkie } from "../../hooks/use-talkie-walkie";
import channelImage from "../../assets/images/channel.png";
import starFullImage from "../../assets/images/star-full.png";
import starEmptyImage from "../../assets/images/star-empty.png";
import { useMemo, useState } from "react";
import Text from "../../../../components/ui/Text";
import { useAudioEffects } from "../../../../hooks/use-audio-effects";
import clickSound from "../../../../assets/audio/click.wav";

type Props = {
  className?: string;
  channel: ChannelType;
  onChannelSelect: (channel: ChannelType) => void;
};

const Channel = ({ className = "", channel, onChannelSelect }: Props) => {
  const [toggling, setToggling] = useState(false);
  const { playEffect } = useAudioEffects();

  const {
    addChannelToFavorites,
    removeChannelFromFavorites,
    favoriteChannels,
  } = useTalkieWalkie();
  const isChannelFavorited = useMemo(
    () => favoriteChannels.some((fc) => fc.id === channel.id),
    [channel.id, favoriteChannels]
  );

  function toggleFavorite() {
    setToggling(true);
    if (isChannelFavorited) {
      removeChannelFromFavorites(channel);
    } else {
      addChannelToFavorites(channel);
    }

    setTimeout(() => {
      setToggling(false);
    }, 150);
  }

  return (
    <div
      onClick={() => onChannelSelect(channel)}
      className="p-[1px] rounded-md bg-gradient-to-b from-[#5a5b61] via-[#5a5b61]/20 to-transparent hover:opacity-80 cursor-pointer"
    >
      <div
        style={{
          backgroundImage: "radial-gradient(circle, #2d2f36 0%, #21232b 100%)",
        }}
        className="rounded-md flex items-center justify-between p-[7px]"
      >
        {/** Icon & MHZ */}
        <div className="flex items-center space-x-2">
          <div
            style={{
              backgroundImage: `radial-gradient(circle, rgba(255, 255, 255, 0.27) 0%, rgba(255, 255, 255, 0.11) 100%)`,
            }}
            className="w-fit p-1 rounded-sm px-[6px]"
          >
            <img
              src={channelImage}
              alt="Channel"
              className="w-[7px] h-[13px]"
            />
          </div>
          <Text size="xxs" className="text-white/60 font-thin">
            {channel.mhz} MhZ
          </Text>
        </div>
        {/** Favorites button */}
        <button
          disabled={toggling}
          title="Toggle favorite"
          className="p-1"
          onClick={() => {
            toggleFavorite();
            playEffect(clickSound);
          }}
        >
          <img
            alt="fav"
            src={isChannelFavorited ? starFullImage : starEmptyImage}
            className={`w-[11px] h-[11px]  ${toggling && "animate-spin"}`}
          />
        </button>
      </div>
    </div>
  );
};

export default Channel;
